<template>
  <div id="manage" class="manage">
    <!-- 管理团队 -->
    <swiper :options="swiperOption" ref="mySwiper">
      <swiper-slide
        class="header-img"
        :style="{ backgroundImage: 'url(' + teamimglist.loop1 + ')' }"
      >
        <!-- <img :src="teamimglist.loop1" class="banner-img" /> -->
      </swiper-slide>
      <swiper-slide
        class="header-img"
        :style="{ backgroundImage: 'url(' + teamimglist.loop2 + ')' }"
      >
        <!-- <img :src="teamimglist.loop2" class="banner-img" /> -->
      </swiper-slide>
    </swiper>
    <img src="../../assets/company/left_bg.png" class="fixed-img" />
    <div class="team-box">
      <ul class="team-list">
        <li
          v-for="(item, index) in teamlist"
          :key="index"
          :class="index <= 1 ? twolist : lastlist"
        >
          <div class="img-box">
            <img :src="item.thumb" class="main-img" />
            <!-- 文字背景图 -->
            <img
              src="../../assets/company/texture.png"
              class="bottom-img"
              v-show="index <= 1"
            />
            <img
              src="../../assets/company/text_bg.png"
              class="last-img"
              v-show="index > 1"
            />
            <div class="bottom-info">
              <img
                src="../../assets/company/YANGFENG.png"
                class="label"
                v-show="index > 1"
              />
              <strong class="title">{{ item.name }}</strong>
              <span class="job" v-show="index <= 1">{{ item.position }}</span>
            </div>
          </div>
          <div class="info-box">
            <span class="group" :class="{ 'group-two': index > 1 }">
              {{ item.title }}
            </span>
            <p class="desc" v-html="item.content">{{ item.content }}</p>
            <img
              src="../../assets/company/line.png"
              class="line"
              v-show="index <= 1"
            />
            <img
              src="../../assets/company/Management.png"
              class="management"
              v-show="index <= 1"
            />
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
// import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  data() {
    return {
      teamlist: [],
      twolist: "twolist",
      lastlist: "lastlist",
      teamimglist: {},
      // [require("../../assets/team/team1.jpg"),require("../../assets/team/、、//team2.jpg")]
      swiperOption: {
        autoplay: {
          delay: 3500,
          disableOnInteraction: false
        },
        speed: 3000
        // ,
        // slidePerView: 1
      }
    };
  },
  created() {
    this.getteamlist();
  },
  methods: {
    getteamlist() {
      this.axios.get("https://admin.jsdkgjt.com/wp-json/team/1").then(res => {
        this.teamlist = res.data;
      });
      //http://website.example.com/wp-json/page/409
      this.axios.get("https://admin.jsdkgjt.com/wp-json/page/409").then(res => {
        this.teamimglist = res.data[0];
      });
    }
  }
};
</script>
<style scoped>
.header-img {
  height: calc(100vh - 140px);
  width: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.banner-img {
  height: 84.84vh;
  width: 100%;
}
.team-box {
  width: 1000px;
  padding: 70px 0;
  margin: 0 auto;
}
.team-list {
  overflow: hidden;
}
.team-list li {
  list-style: none;
  display: block;
  overflow: hidden;
  padding-bottom: 60px;
}
.img-box {
  width: 20%;
  float: left;
  position: relative;
  padding-right: 40px;
}
.lastlist .img-box {
  width: 100%;
  float: none;
}
.lastlist .info-box {
  text-align: right;
}
.team-list li.lastlist .img-box .main-img {
  z-index: 0;
  position: absolute;
  right: 0;
  bottom: 0;
  width: 92px;
}
.img-box .bottom-img {
  max-width: 70%;
  position: absolute;
  left: 0;
  bottom: -30px;
  z-index: 1;
}
.team-list li.lastlist .img-box .last-img {
  max-width: 100%;
  z-index: 0;
  width: 100%;
  /* width: 396px; */
  height: 90px;
  display: block;
}
.img-box .bottom-info {
  position: absolute;
  left: 7px;
  bottom: -19px;
  z-index: 2;
}
.img-box .bottom-info .job {
  display: block;
  font-size: 14px;
  /* font-family: SourceHanSansCN-Normal; */
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 27px;
  width: 128px;
}
.info-box {
  width: 80%;
  float: left;
}
.info-box .desc {
  /* max-width: 58%; */
  padding-top: 30px;
  font-size: 16px;
  /* font-family: SourceHanSansCN-Normal; */
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 27px;
}
.info-box .management {
  max-width: 100%;
  display: block;
  padding-top: 20px;
}
.info-box .group {
  font-size: 20px;
  font-weight: 400;
  color: rgba(174, 148, 108, 1);
  line-height: 31px;
  /* max-width: 58%; */
  display: block;
}
.info-box .group-two {
  font-size: 20px;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
  line-height: 29px;
  opacity: 0.2;
}
.team-list li.lastlist {
  padding: 20px 0;
  width: 50%;
  float: left;
  padding-top: 70px;
}
.team-list li.lastlist .info-box {
  padding-left: 0;
  padding-top: 20px;
  padding-bottom: 50px;
  width: 100%;
  text-align: right;
}
.team-list li.lastlist .info-box .desc {
  padding-top: 5px;
  min-height: 59px;
  padding-left: 50px;
}
.img-box .bottom-info .title {
  display: block;
  color: #ffffff;
  font-size: 18px;
}
.team-list li.lastlist .img-box .bottom-info .title {
  color: #cca04d;
  display: block;
  width: 100%;
  white-space: nowrap;
}
.team-list li.lastlist .img-box {
  padding-right: 0;
}
.team-list li.lastlist .label {
  width: 82px;
  /* display: block; */
}
.manage {
  position: relative;
  width: 100%;
}
.fixed-img {
  position: absolute;
  left: 0;
  padding-top: 70px;
  height: 224px;
  width: calc((100% - 993px) / 2);
}
.main-img {
  width: 100%;
}
.lastlist .info-box .group,
.lastlist .info-box .desc {
  /* max-width: 396px; */
  max-width: 100%;
}
.lastlist .img-box .bottom-info {
  right: 200px;
  bottom: 15px;
  text-align: right;
}
.swiper-container {
  width: 100%;
}
</style>
